'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _badge = require('antd/lib/badge');

var _badge2 = _interopRequireDefault(_badge);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = BadgeComponent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BadgeComponent(props) {
	var className = (0, _classnames2.default)((0, _defineProperty3.default)({
		'mk-badge': true
	}, props.className, !!props.className));
	return _react2.default.createElement(_badge2.default, (0, _extends3.default)({}, props, { className: className }));
}
module.exports = exports['default'];